<!--
 * @Description: 项目执行进度
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="675" :itemWidth="420 + 56">
      <div v-for="(item, index) in TYPE_MAPPING" :key="index">
        <div
          class="xrk-card"
          @click="onChange(item.value)"
          style="width: 420px; height: 600px"
        >
          <div
            :style="{
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            }"
          >
            <component
              v-if="titleCmpt"
              :is="titleCmpt"
              style="
                width: 1200px;
                transform: scale(0.33);
                transform-origin: 0 center;
              "
              v-bind="{
                innerText: '项目执行进度',
                enInnerText: 'Project Implementation Progress',
                index: 9
              }"
            />
            <component style="width: 380px; height: 300px" :is="item.cmpt" />

            <component
              style="width: 60px; height: 30px"
              v-if="pageNoCmpt"
              :is="pageNoCmpt"
            />
          </div>
        </div>
        <div class="bi-tmpl-detail__right__cmpt__radioBox">
          <BaseRadio
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            {{}}
          </BaseRadio>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

import cmpts from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-standard';

const TYPE_MAPPING = cmpts.reduce((pre, cur) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: cName
  };
  return pre;
}, {});

const { curItem, onChange, titleCmpt, pageNoCmpt } = useDetailCmpt({});
</script>
<style lang="scss" scoped>
.des {
  box-sizing: border-box;
  padding: 10px 15px;
  border: dashed 2px #efefef;
  border-radius: 6px;

  > h3 {
    color: var(--theme-color-1);
  }
}
</style>
